import { createAction, props } from '@ngrx/store';
import { HqProfessionalView } from '../../model/src';

const upsertHqProfessionalSuccess = createAction(
  '[HqProfessional From Store] Upsert headquarter professional SUCCESS',
  props<{ hqProfessionalView: HqProfessionalView }>()
);

const joinHqSuccess = createAction(
  '[HqProfessional From Store] Attach professional to current headquarter SUCCESS',
  props<{ hqProfessionalView: HqProfessionalView }>()
);

export const HqProfessionalFormActions = {
  upsertHqProfessionalSuccess,
  joinHqSuccess,
};
